module.exports = "/static/assets/605de00c0d558339efa3bbc72ba44d5c.png";